import type { PayoutLessonVM, PayoutLessonsContext } from "@shared-kernel/application/ports/shared/shared-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

type Payload = PayoutLessonsContext & { payoutId: string };

export const retrieveTeacherPayoutLessons = createApiThunk<PayoutLessonVM[], Payload>(
  "payoutLessons/teacherRetrievePayoutLessons",
  async (payload, { extra: { sharedRepository } }) => {
    const { payoutId, ...context } = payload;
    return sharedRepository!.getPayoutLessons(payoutId, context);
  },
);
